import { memo } from "react";

import { ColocaLogo } from "@/shared/components/ColocaLogo";
import LiquidEther from "@/shared/components/LiquidEther";
import type { LoginTranslations } from "@/shared/lang/interfaces/login";

const MemoizedLiquidEther = memo(() => (
  <div
    style={{
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }}
  >
    <LiquidEther
      colors={["#7be4c8", "#3dc7a9", "#0fa388"]}
      mouseForce={20}
      cursorSize={100}
      isViscous={false}
      viscous={30}
      iterationsViscous={32}
      iterationsPoisson={32}
      resolution={0.5}
      isBounce={false}
      autoDemo={true}
      autoSpeed={0.5}
      autoIntensity={2.2}
      takeoverDuration={0.25}
      autoResumeDelay={3000}
      autoRampDuration={0.6}
    />
  </div>
));

MemoizedLiquidEther.displayName = "MemoizedLiquidEther";

export const LangComponent = memo(
  ({
    t,
  }: {
    t: <K extends keyof LoginTranslations>(key: K, options?: Record<string, unknown>) => LoginTranslations[K];
  }) => {
    const [subtitleBefore, subtitleAfter] = t("subtitle").split("{emphasis}");

    return (
      <div className="flex w-full h-screen items-center py-5 flex-col relative bg-[#003329] dark:bg-zinc-900">
        <MemoizedLiquidEther />
        <div className="flex flex-col gap-10 justify-center h-full max-w-2xl 2xl:px-5 px-20">
          <h1 className="animate-fade-left font-outfit font-bold 2xl:text-6xl text-5xl leading-tight tracking-tight text-white drop-shadow-md selection:bg-green-600/50 selection:text-white">
            {t("title")} <span className="italic font-light text-green-100">{t("title_emphasis")}</span>
          </h1>
          <p className="animate-fade-left font-poppins font-medium 2xl:text-2xl text-xl leading-relaxed text-white/90 drop-shadow-md selection:bg-green-600/50 selection:text-white">
            {subtitleBefore}
            <span className="font-semibold text-green-100">{t("subtitle_emphasis")}</span>
            {subtitleAfter}
          </p>
        </div>
        <div className="max-w-36 mb-10 animate-fade-up">
          <ColocaLogo variant="white" />
        </div>
      </div>
    );
  },
);
